import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { initialQuickReplyTemplateState } from "./defaultState";
import {
  FETCH_QUICK_REPLY_TEMPLATE_LIST_PROGRESS,
  FETCH_QUICK_REPLY_TEMPLATE_LIST_SUCCESS,
  FETCH_QUICK_REPLY_TEMPLATE_LIST_FAILED,
  FETCH_QUICK_REPLY_TEMPLATE_PROGRESS,
  FETCH_QUICK_REPLY_TEMPLATE_SUCCESS,
} from "./quickReplyTemplateAction";

export const quickReplyTemplateReducer = (
  state: IStoreState["quickReplyTemplate"] = initialQuickReplyTemplateState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_QUICK_REPLY_TEMPLATE_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.NotLoaded;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_QUICK_REPLY_TEMPLATE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
        // Old paging structure (kept for reference)
        // draftState.list.paging = paging;
      });
    }

    case FETCH_QUICK_REPLY_TEMPLATE_LIST_FAILED: {
      const { errorMessage } = action?.payload || "Something went wrong";
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage || "Something went wrong";
      });
    }
    case FETCH_QUICK_REPLY_TEMPLATE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.quickReplyTemplateData.loading = LoadState.InProgress;
        draftState.quickReplyTemplateData.data =
          initialQuickReplyTemplateState.quickReplyTemplateData.data;
      });
      return newState;
    }
    case FETCH_QUICK_REPLY_TEMPLATE_SUCCESS: {
      const { data } = action.payload;

      const newState = produce(state, (draftState) => {
        draftState.quickReplyTemplateData.loading = LoadState.Loaded;
        draftState.quickReplyTemplateData.data = data;
      });

      return newState;
    }

    default: {
      return state;
    }
  }
};
